import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import { Button, Row, Span } from 'components'
import { BorderLineSuccess } from 'components/BorderLine/BorderLine'
import { DraggableDialog } from 'components/DraggableDialog/DraggableDialog'
import { useRef } from 'react'
import Draggable from 'react-draggable'
import { FONTS, SPACING, TYPOGRAPHY, COLORS } from 'utils'

export type SucessModalType = 'alert' | 'sucess' | 'error'

interface ISuccessModal {
  open: boolean
  message: string
  type: SucessModalType
  hideButtonConfirm?: boolean
  hideButtonCancel?: boolean
  handleCancel?: () => void
  handleConfirm?: () => void
  txtButtonConfirm?: string
  txtButtonCancel?: string
  titleModal?: string | undefined
  typeButtonCancel?: 'text' | 'outlined' | 'default'
  typeButtonConfirm?: 'text' | 'outlined' | 'default'
}

export const SuccessModal = ({
  open,
  handleConfirm,
  handleCancel,
  hideButtonCancel = false,
  hideButtonConfirm = false,
  txtButtonCancel = 'Não',
  txtButtonConfirm = 'Sim',
  message,
  titleModal,
  type,
  typeButtonCancel = 'text',
  typeButtonConfirm = 'default'
}: ISuccessModal) => {
  const titlesModal = {
    alert: 'Alerta',
    error: 'Error',
    sucess: 'Sucesso'
  }

  const colorModal = {
    alert: COLORS.alert,
    error: COLORS.error,
    sucess: COLORS.success
  }

  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      showModal={open}
      width={'sm'}
      reference={draggableReference}
    >
      <BorderLineSuccess colorLine={colorModal[type]} />
      <DialogTitle>
        <Span
          color={colorModal[type]}
          text={!titleModal ? titlesModal[type] : titleModal}
          fontSize={TYPOGRAPHY.titleSize32}
          fontWeight={FONTS.bold}
        />
      </DialogTitle>
      <DialogContent>
        <Row marginBottom={SPACING.spacing30} justifyContent="flex-start">
          <Span
            color={COLORS.black}
            text={message}
            fontSize={TYPOGRAPHY.bodySize16}
            fontWeight={FONTS.regular}
          />
        </Row>
        <Row justifyContent="flex-end" marginBottom={SPACING.spacing20}></Row>
      </DialogContent>
      <DialogActions>
        {!hideButtonCancel && (
          <Button
            text={txtButtonCancel}
            onClick={() => {
              handleCancel()
            }}
            variantButton={typeButtonCancel}
            textColor={colorModal[type]}
          />
        )}
        {!hideButtonConfirm && (
          <Button
            text={txtButtonConfirm}
            onClick={() => {
              handleConfirm()
            }}
            borderColor={colorModal[type]}
            backgroundColor={colorModal[type]}
            textColor={COLORS.white}
            variantButton={typeButtonConfirm}
          />
        )}
      </DialogActions>
    </DraggableDialog>
  )
}
